import {
  SANCTION_ADD_REQUEST,
  SANCTION_ADD_REQUEST_FAILURE,
  SANCTION_ADD_REQUEST_SUCCESS,
  SANCTION_CLEAN_REQUEST,
  SANCTION_FETCH_REQUEST,
  SANCTION_FETCH_REQUEST_FAILURE,
  SANCTION_FETCH_REQUEST_SUCCESS,
  SANCTION_UPDATE_REQUEST,
  SANCTION_UPDATE_REQUEST_FAILURE,
  SANCTION_UPDATE_REQUEST_SUCCESS,
  SINGLE_SANCTION_CLEAN_REQUEST,
  SINGLE_SANCTION_FETCH_REQUEST,
  SINGLE_SANCTION_FETCH_REQUEST_SUCCESS,
  SINGLE_SANCTION_FETCH_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
  singlePayload: [],
  singleLoading: false,
  singleError: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const sanctionsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SANCTION_ADD_REQUEST:
    case SANCTION_FETCH_REQUEST:
    case SANCTION_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SANCTION_ADD_REQUEST_SUCCESS:
    case SANCTION_FETCH_REQUEST_SUCCESS:
    case SANCTION_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '15', '20'],
        },
      });

    case SANCTION_ADD_REQUEST_FAILURE:
    case SANCTION_FETCH_REQUEST_FAILURE:
    case SANCTION_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case SANCTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
        pagination: {},
        singleLoading: false,
        singlePayload: [],
        singleError: {},
      });

    case SINGLE_SANCTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: [],
        singleError: {},
      });

    case SINGLE_SANCTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_SANCTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleError: {},
      });

    case SINGLE_SANCTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleError: action.error,
      });

    default:
      return state;
  }
};

export default sanctionsReducer;
